(() => {
  let scheduled = false;
  let captionId = 0;
  function refresh() {
    scheduled = false;
    document.querySelectorAll('[data-atl-rating].klaviyo-star-rating-widget').forEach((mount) => {
      const link = mount.querySelector('.kl_reviews__star_rating_widget');
      const label = mount.querySelector('.kl_reviews__star_rating_widget__label');
      if (!link || !label) return;
      // The provider's accessible label supplies the actual score and count.
      const values = link.getAttribute('aria-label')?.match(/^([\d.]+)\s+stars?,\s+([\d,]+)\s+reviews?/i);
      if (values) {
        const rating = Number(values[1]);
        const count = Number(values[2].replaceAll(',', ''));
        mount.hidden = count === 0;
        if (count > 0 && rating >= 1 && rating <= 5) {
          const countText = (count === 1 ? mount.dataset.countOne : mount.dataset.countMany)
            .replace('[count]', count.toLocaleString('en'));
          const caption = `${rating.toFixed(1)} (${countText})`;
          if (label.textContent !== caption) label.textContent = caption;
          if (!label.id) {
            do { captionId += 1; } while (document.getElementById(`atl-review-caption-${captionId}`));
            label.id = `atl-review-caption-${captionId}`;
          }
          link.setAttribute('aria-labelledby', label.id);
        }
      }
      const href = mount.dataset.main === 'true'
        ? '#klaviyo-reviews-all'
        : `${mount.dataset.productUrl}#klaviyo-reviews-all`;
      if (link.tagName === 'A') {
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      } else {
        link.setAttribute('role', 'link');
        link.tabIndex = 0;
        link.dataset.atlReviewHref = href;
      }
    });
  }
  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(refresh);
    }
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label']
  });
  function navigate(event) {
    const link = event.target.closest?.('[data-atl-review-href]');
    if (!link || (event.type === 'keydown' && event.key !== 'Enter')) return;
    event.preventDefault();
    window.location.assign(link.dataset.atlReviewHref);
  }
  document.addEventListener('click', navigate);
  document.addEventListener('keydown', navigate);
  schedule();
})();
